import { useIsInternalAccount } from "../useIsInternalAccount";
import { useUser } from "../useUser";

export const useCreatorDashboardAccess = (): boolean => {
  const internal = useIsInternalAccount();
  const { allstarUser } = useUser();
  // Navigation visibility only; the brand review API verifies current admin access.
  return internal || allstarUser?.isAdmin === true;
};
